import React from "react";
import { Button, Checkbox, Image } from "antd";
import { Product } from "common/interfaces";
import { Link } from "react-router-dom";
import { UTCToJapanTime } from "common/helper/time.helper";
import { ProductStatusMap } from "common/enums/Product.enum";
import { FILE_BASE_URL } from "config/apiConfig";
import { formatProductQuantity, productPrice } from "common/utils";

interface ProductCompanyItemProps<T extends Product> {
  product: T;
  checked: boolean;
  onSelect: (code: string, checked: boolean) => void;
}

export function ProductCompanyItem<T extends Product>({
  product,
  checked,
  onSelect,
}: ProductCompanyItemProps<T>) {
  const timeJapan = UTCToJapanTime(product.created_at);

  return (
    <div className="self-stretch bg-white rounded-md flex flex-col justify-start items-start overflow-hidden">
      <div
        data-プロパティ1="base + checkbox"
        className="self-stretch min-h-10 px-12 py-2.5 relative bg-primary inline-flex justify-center items-center gap-2.5"
      >
        <div className="flex-1 text-center justify-start text-white text-sm font-bold font-['Noto_Sans_JP'] leading-snug">
          申請ID #{product.code}
        </div>
        <div
          data-プロパティ1="active - border"
          className="w-7 h-7 py-[3px] left-[10px] top-[6px] absolute bg-primary rounded-md inline-flex flex-col justify-center items-center gap-2.5 overflow-hidden"
        >
          <Checkbox
            checked={checked}
            onChange={(e) => onSelect(product.code, e.target.checked)}
          />
        </div>
      </div>
      <div className="self-stretch min-h-10 p-5 bg-white rounded-bl-md rounded-br-md border-l border-r border-b border-neutral-300 flex flex-col justify-center items-center gap-5">
        <div className="self-stretch inline-flex justify-start items-center gap-3.5">
          <Image
            src={`${FILE_BASE_URL}/${product.image_url}`}
            className="!w-[60px] !h-[60px] object-cover"
          />
          <div className="flex-1 min-w-32 inline-flex flex-col justify-start items-start gap-0.5">
            <div className="self-stretch justify-start text-black text-base font-normal font-['Noto_Sans_JP'] leading-normal">
              廃プラスチック
            </div>
            <div className="self-stretch justify-start text-black text-xs font-bold font-['Noto_Sans_JP'] leading-tight">
              {productPrice(product)}
            </div>
          </div>
        </div>
        <div className="self-stretch inline-flex justify-start items-start gap-3.5 flex-wrap content-start">
          <div className="flex-1 min-w-32 inline-flex flex-col justify-start items-start gap-[3px]">
            <div className="self-stretch justify-start text-slate-400 text-[13px] font-normal font-['Noto_Sans_JP'] leading-tight">
              数量
            </div>
            <div className="self-stretch justify-start text-black text-[15px] font-normal font-['Noto_Sans_JP'] leading-normal">
              {formatProductQuantity(product)}
            </div>
          </div>
          <div className="flex-1 min-w-32 inline-flex flex-col justify-start items-start gap-[3px]">
            <div className="self-stretch justify-start text-slate-400 text-[13px] font-normal font-['Noto_Sans_JP'] leading-tight">
              出品日
            </div>
            <div className="self-stretch justify-start text-black text-[15px] font-normal font-['Noto_Sans_JP'] leading-normal">
              {`${timeJapan.year}/${timeJapan.month}/${timeJapan.day} ${timeJapan.hour}:${timeJapan.minute}`}
            </div>
          </div>
          <div className="flex-1 min-w-32 inline-flex flex-col justify-start items-start gap-[3px]">
            <div className="self-stretch justify-start text-slate-400 text-[13px] font-normal font-['Noto_Sans_JP'] leading-tight">
              ステータス
            </div>
            <div className="self-stretch justify-start text-black text-[15px] font-normal font-['Noto_Sans_JP'] leading-normal">
              {ProductStatusMap[product.status]}
            </div>
          </div>
        </div>
        <Link
          to={`/admin/company-management/${product.company_id}/product/${product.code}/view`}
          className="w-full"
        >
          <Button
            block
            type="primary"
            htmlType="button"
            className="w-full min-h-[50px] bg-primary-light text-primary text-[16px] font-bold"
          >
            商品詳細画面へ
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default ProductCompanyItem;
